import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import {
    Button, CircularProgress,
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import MotovehiculoForm from './Forms/MotovehiculoForm';
import TitularForm from './Forms/TitularForm';
import CoberturaForm from './Forms/CoberturaForm';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';
import axios from 'axios';
import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import CotizarContext from "../../../../../context/CotizarContext";
import IndicatorsContext from "../../../../../context/AdviserContext/IndicatorsContext";
import moment from "moment";
import AuthContext from "../../../../../context/AuthContext";
import motorbike_white_icon from "../../../../../assets/images/white_motorbike_icon.png";

const steps = ['Información', 'Titular', 'Cobertura'];
const {formId, formField} = formModel;


function _renderStepContent(step, marcas, setMarcas, modelos, setModelos, anios, setAnios, cotizacionRetomada, vehicleDetails) {
    switch (step) {
        case 0:
            return <MotovehiculoForm
                cotizacionRetomada={cotizacionRetomada}
                formField={formField}
                vehicleDetails={vehicleDetails}
            />;
        case 1:
            return <TitularForm formField={formField} cotizacionRetomada={cotizacionRetomada}/>;
        case 2:
            return <CoberturaForm cotizacionRetomada={cotizacionRetomada} formField={formField}/>;
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutPage(props) {
    const cotizacionRetomada = props.cotizacionRetomada; //Indicates if it's a new quote or it isn't
    const nuevoFormInitialValues = props.cotizacionValues;
    const action = props.action;
    const {authToken} = useContext(AuthContext);
    const vehicleDetails = useRef({
        detalle_marca: "",
        detalle_version: ""
    })

    let nuevoInitialValues;
    if (cotizacionRetomada) {
        //Si la fecha de hoy es despues de la fecha cotización
        if (moment(moment().format('YYYY-MM-DD')).isAfter(nuevoFormInitialValues['FechaCotizacion']))
            nuevoFormInitialValues['FechaCotizacion'] = moment().format('YYYY-MM-DD');

        vehicleDetails.current = {
            detalle_marca: nuevoFormInitialValues.DetalleMarca,
            detalle_version: nuevoFormInitialValues.DetalleVersion
        }

        nuevoInitialValues = {
            motovehiculo: {
                'marca': parseInt(nuevoFormInitialValues.Marca),
                'anio': nuevoFormInitialValues.Anio,
                'version': nuevoFormInitialValues.Modelo,
                "modeloCodigo": nuevoFormInitialValues.Modelo,
                "valorAdicional": parseInt(nuevoFormInitialValues.ValorTotalAccesorios),
                "usoVehiculo": nuevoFormInitialValues.UsoVehiculo,
                "ceroKm": nuevoFormInitialValues.CeroKm.toString(),
                "detalle_marca": nuevoFormInitialValues.DetalleMarca,
                "detalle_version": nuevoFormInitialValues.DetalleVersion
            },
            "situacionImpositiva": nuevoFormInitialValues.SituacionImpositiva,
            "tipoPersona": nuevoFormInitialValues.PersonaJuridica.toString(),
            "codigosLocalidad": nuevoFormInitialValues.CodigoPostal + ',' + nuevoFormInitialValues.Localidad,
            "vigencia": nuevoFormInitialValues.Vigencia,
            "frecuenciaPago": nuevoFormInitialValues.FrecuenciaPago,
            "cuotas": nuevoFormInitialValues.Cuotas,
            "equipoTelematica": "",
            "idCotizar": nuevoFormInitialValues.idCotizacion,
            "afinidad": nuevoFormInitialValues.idAfinidad.toString(),
            "fechaCotizacion": nuevoFormInitialValues['FechaCotizacion'],

            "is_saved": true,
            "sumaAsegurada": nuevoFormInitialValues['SumaAsegurada'],
            "ajusteAutomatico": nuevoFormInitialValues.AjusteAutomatico ? nuevoFormInitialValues.AjusteAutomatico : "0",
        }
        if (nuevoFormInitialValues['Clientes'] !== null) {
            nuevoInitialValues = {
                ...nuevoInitialValues,
                "nombre": nuevoFormInitialValues['Clientes']['Nombre'],
                "apellido": nuevoFormInitialValues['Clientes']['Apellido'],
                "dni": nuevoFormInitialValues['Clientes']['DNI'],
                "email": nuevoFormInitialValues['Clientes']['Email'],
                "patente": nuevoFormInitialValues['Clientes']['Patente'],
                "telefono": nuevoFormInitialValues['Clientes']['CodArea'] + nuevoFormInitialValues['Clientes']['Telefono'],
            }
        }
    }

    const handlerEndCotizacion = props.handlerEndCotizacion;
    const setIsCotizarDone = props.setIsCotizarDone;
    const setIsCotizando = props.setIsCotizando;
    const [isCotizarDone2, setIsCotizarDone2] = useState(false);
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(action === 'emitir' ? steps.length : 0);

    const currentValidationSchema = validationSchema[activeStep];
    const [cotizacionResponse, setCotizacionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);

    const [marcas, setMarcas] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [anios, setAnios] = useState([]);

    const [saved, setSaved] = useState(false)


    const {afinidadesPic} = useContext(CotizarContext)
    const {handleModified} = useContext(IndicatorsContext)

    async function _submitForm(values, actions) {
        setIsCotizarDone2(false)
        setIsCotizando(true)
        let url = process.env.REACT_APP_BACK_SERVER + '/cotizar/motovehiculo';

        values.origen = "affinity"
        if (values.vigencia === '1') // Vigencia Anual
            values.frecuenciaPago = '5';    // Frecuencia Mensual
        else
            values.frecuenciaPago = '7';    // Frecuencia Cuotas

        afinidadesPic.map(af => {
            if (af.id === values.afinidad) {
                values.img_afinidad = af.pic;
            }
        })

        setFinalValues(values);

        if (typeof values.modelo === "string")
            values.modelo = values.modeloCodigo


        let data = saved ?
            {
                saveToDatabase: true,
                idCotizar: cotizacionResponse['cotizacionId'],
                is_saved: saved,
            } :
            {saveToDatabase: true}

        setIsCotizarDone(false)

        values.motovehiculo = {
            ...(saved ? {} : { sumaAsegurada: 0 }),
            ...values.motovehiculo,
            ...vehicleDetails?.current
        }

        axios.post(url, {...values, ...data}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }).then(res => {
            setCotizacionResponse({
                ...res.data,
                "plans": res.data.plans.filter(plan => plan.outStandard === "false")
            });

            if (!saved) {
                values.motovehiculo.sumaAsegurada = parseInt(res.data['vehicleValuation'])
                handleModified()
            }

            setSaved(true)
            setIsCotizarDone2(true)
        }).catch(err => {
            console.log(err);
        });
        if (action !== 'emitir')
            actions.setSubmitting(false);
    }

    function _handleSubmit(values, actions) {
        if (activeStep > 1) {
            _submitForm(values, actions);
        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    useEffect(() => {
        if (action === 'emitir') {
            if (cotizacionResponse !== null) {
                handlerEndCotizacion(finalValues, cotizacionResponse)
            } else {
                setFinalValues(nuevoInitialValues)
                _submitForm(nuevoInitialValues);
            }
        } else {
            if (cotizacionResponse !== null) {
                handlerEndCotizacion(finalValues, cotizacionResponse)
            }
        }
    }, [isCotizarDone2]);

    return (
        <React.Fragment>

            {action !== 'emitir'
            &&
            <div className={classes.formBox}>
                <>
                    {isCotizarDone2
                    && handlerEndCotizacion(finalValues, cotizacionResponse)
                    }
                </>

                <div className={classes.iconCircle}>
                    <img src={motorbike_white_icon} alt="motorbike_icon" style={{width: "40px", height: "auto"}}/>
                </div>
                <div style={{margin: "24px 0"}}>
                    <ProgressBar activeStep={activeStep} stepTitles={steps}/>
                </div>

                <Fragment>
                    {activeStep > 2 ? (
                        <Fragment>
                            {isCotizarDone2
                                ? handlerEndCotizacion(finalValues, cotizacionResponse)
                                : null
                            }
                        </Fragment>
                    ) : null}

                    <Formik
                        initialValues={cotizacionRetomada ? nuevoInitialValues : formInitialValues}
                        validationSchema={currentValidationSchema}
                        validateOnBlur={false}
                        onSubmit={_handleSubmit}
                    >
                        {({isSubmitting}) => (
                            <Form id={formId}>

                                {_renderStepContent(activeStep, marcas, setMarcas,
                                    modelos, setModelos, anios, setAnios, cotizacionRetomada, vehicleDetails)}

                                <div className={classes.buttons}>
                                    {activeStep !== 0 &&
                                    <Button
                                        onClick={_handleBack}
                                        variant="contained"
                                        className={classes.backButton}
                                        disabled={isSubmitting}
                                    >
                                        Atras
                                    </Button>
                                    }
                                    <Button
                                        disabled={isSubmitting}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className={classes.buttonContained}
                                    >
                                        {activeStep > 1 ? "Solicitar cotización" : "Siguiente"}
                                    </Button>
                                    {isSubmitting && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Fragment>
            </div>}
        </React.Fragment>
    );
}
